import React from "react";
import PropTypes from "prop-types";
import Slider from "rc-slider";
import 'rc-slider/assets/index.css';
import NumberInput from "./NumberInput";
import { CSCContext } from "../CSCContext";

// TODO: Make this more accessible to screen readers

class SliderInput extends React.Component {
	static contextType = CSCContext;
	
	constructor(props) {
		super(props);
		this.trackDisplayStyle = props.marks ? "none" : "block";
		this.step = props.step;
		if (this.step === undefined) {
			this.step = Math.round((props.max - props.min)/100);
		}
	}

	updateValue(newValue) {
		//TODO: If user tries to go outside range display a toast notification warning them
		// instead of silently blocking them
		if (newValue >= this.props.min && newValue <= this.props.max) {
			this.context.setUserData(this.props.name, Number(newValue));
		}
	}

	componentDidMount() {
		this.updateValue(this.context.getUserData(this.props.name) || this.props.value);
	}

	render() {
		return (
			<div id={this.props.name} className="slider-input">
				<label>{this.props.label + ' '}
					{ this.props.marks ? null : (
						<NumberInput 
							name={this.props.name}
							value={this.context.getUserData(this.props.name)}
							prefix={this.props.prefix}
							onChange={ e => this.updateValue(e.target.value) } 
						/>
					)}
				</label>
				<Slider
					value={this.context.getUserData(this.props.name)}
					min={this.props.min}
					max={this.props.max}
					step={this.step}
					vertical={this.props.vertical}
					reverse={this.props.reverse}
					marks={this.props.marks ? this.props.marks : false}
					trackStyle={{display: this.trackDisplayStyle}}
					onChange={(value) => {
						this.updateValue(value);
					}}
				/>
			</div>
		);
	}
}

SliderInput.propTypes = {
	name: PropTypes.string.isRequired,
	value: PropTypes.number,
	label: PropTypes.string,
	min: PropTypes.number,
	max: PropTypes.number,
	step: PropTypes.number,
	vertical: PropTypes.bool,
	reverse: PropTypes.bool,	
	marks: PropTypes.object,
	prefix: PropTypes.string,
};

SliderInput.defaultProps = {
	value: 0,
	label: "",
	min: 0,
	max: 999999999,
	vertical: false,
	reverse: false,
	marks: null,
	prefix: '',
};

export default SliderInput;